import { render, staticRenderFns } from "./reconciliationCompleted.vue?vue&type=template&id=70b220d1&scoped=true"
import script from "./reconciliationCompleted.vue?vue&type=script&lang=js"
export * from "./reconciliationCompleted.vue?vue&type=script&lang=js"
import style0 from "./reconciliationCompleted.vue?vue&type=style&index=0&id=70b220d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b220d1",
  null
  
)

export default component.exports